export default __webpack_public_path__ + "static/media/Rectangle33.41eef0f7.png";